"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const mxw_libs_errors_1 = require("mxw-libs-errors");
class Socket {
    constructor(uri = "wss://mxw-api-dev.usdp.io", path = "/sso-websocket/socket.io") {
        this.uri = uri;
        this.path = path;
    }
    connect() {
        if (null == this.uri || undefined == this.uri || "" == this.uri.trim()) {
            throw mxw_libs_errors_1.createError(mxw_libs_errors_1.errors.INVALID_PARAMETER, "Invalid URI");
        }
        try {
            let opts = {
                autoConnect: false,
                upgrade: false,
                transports: ['websocket', 'polling'],
            };
            if (this.path) {
                opts["path"] = this.path;
            }
            return socket_io_client_1.default.connect(this.uri, opts);
        }
        catch (error) {
            throw mxw_libs_errors_1.createError(mxw_libs_errors_1.errors.UNKNOWN, "Failed to establish connection");
        }
    }
}
exports.default = Socket;
//# sourceMappingURL=socket.js.map